<template>
  <div class="mx-auto px-4 pt-20 pb-40 w-[768px] md:px-8 lg:px-16 z-max">
    <h1 class="text-center text-3xl font-bold">Auto-Complete Your Profile 🚀</h1>
    <div class="mt-1 mb-10 flex items-center justify-center text-center text-slate-400 gap-1.5" >
      Upload your resume & we'll fill out your profile for you.
    </div>

    <ParseResumeModalSelectFile hide-terms-of-service/>
    <ParseResumeModalContent v-model:open="parseResumeStore.resume.showModal"/>

    <template v-if="!hasFile">
      <div class="my-8 flex items-center justify-center space-x-2">
        <div class="h-px w-full flex-1 bg-gradient-to-r from-transparent to-slate-200"/>
        <p class="text-sm font-bold uppercase text-slate-600">Or</p>
        <div class="h-px w-full flex-1 bg-gradient-to-l from-transparent to-slate-200"/>
      </div>
      <div class="flex flex-wrap items-center justify-center gap-4 px-4">
        <FormButton @click="handleNextStep" color="secondary" size="tall"
                    class="opacity-80 hover:opacity-100" medium>
          I don't have a resume – Create Business Draft Profile instead
        </FormButton>
      </div>
    </template>
  </div>
</template>

<script setup>
import FormButton from "./FormButton.vue";
import ParseResumeModalContent from "./ParseResumeModalContent.vue";
import ParseResumeModalSelectFile from "./ParseResumeModalSelectFile.vue";
import {computed, onMounted} from "vue";
import {useParseResumeStore} from "../stores/ParseResumeStore.js";
import {useCandidateProfileStore} from "../stores/CandidateProfileStore.js";
import {mapParsedResumeToCandidateProfileStore} from "../helpers/MapParsedResumeToDifferentStore.js";

const emits = defineEmits(["complete", "prevStep"]);

const parseResumeStore = useParseResumeStore();
const candidateProfileStore = useCandidateProfileStore();

const hasFile = computed(() => !!parseResumeStore.resume.file);

const handleNextStep = () => emits("complete");

onMounted(() => {
  parseResumeStore.addCompletionCallback(() => {
    mapParsedResumeToCandidateProfileStore(parseResumeStore.candidate, parseResumeStore, candidateProfileStore);
    handleNextStep();
  });
});
</script>
